import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Card, CardContent, Typography, Button } from '@mui/material';
import { Add, Inventory, Build } from '@mui/icons-material';
import { ScreenFrame } from '../PrototypeShared';

export default function OperatorAppScreen() {
  return (
    <ScreenFrame
      title="Operator app"
      actions={
        <Button component={Link} to="/prototype/operator/login" variant="outlined" size="small">
          Switch user
        </Button>
      }
    >
      <Typography color="text.secondary" paragraph>
        Operator home: receive goods, move stock, scan for production.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Card component={Link} to="/prototype/receive-goods" sx={{ textDecoration: 'none', color: 'inherit' }}>
            <CardContent>
              <Add color="primary" sx={{ mb: 1 }} />
              <Typography variant="h6">Receive goods</Typography>
              <Typography variant="body2" color="text.secondary">Register incoming delivery</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card component={Link} to="/prototype/stock" sx={{ textDecoration: 'none', color: 'inherit' }}>
            <CardContent>
              <Inventory color="primary" sx={{ mb: 1 }} />
              <Typography variant="h6">Stock</Typography>
              <Typography variant="body2" color="text.secondary">View and move stock</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card component={Link} to="/prototype/production-start" sx={{ textDecoration: 'none', color: 'inherit' }}>
            <CardContent>
              <Build color="primary" sx={{ mb: 1 }} />
              <Typography variant="h6">Production start</Typography>
              <Typography variant="body2" color="text.secondary">Scan pallets for production</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Button component={Link} to="/prototype/dashboard" variant="outlined" sx={{ mt: 2 }}>Back to main app</Button>
    </ScreenFrame>
  );
}
